<script lang="ts" setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '../plugin';

const { login } = useAuth();
const router = useRouter();

onMounted(() => {
  login().catch((error) => {
    router.replace(`/error?message=${error.message || error}`);
  });
});
</script>

<template>
  <n-card
    mx-auto
    my-4
    max-w-500px
  >
    <div text-center>
      <n-spin size="small" />
    </div>
    <div
      mt-3
      text-center
    >
      Connecting...
    </div>
  </n-card>
</template>
